import React from 'react'
import { miniHowItWorksStyle as styles } from './miniHowItWorks.tailwind'
import miniHowItWorksData from './miniHowItWorks.data'

const MiniHowItWorks = () => {
  return (
    <section className={styles.section_wrapper}>
      {/* Centered Heading */}
      <div className={styles.header_wrpr}>
        <h2 className="landing_page_sub_heading">A NEW ERA OF SPORTS ENGAGEMENT</h2>
      </div>

      {/* Steps List */}
      <div className={styles.list_container}>
        {miniHowItWorksData.map((step) => (
          <div key={step.id} className={styles.step_row}>
            {/* Number */}
            <span className={styles.number}>{step.id}</span>
            {/* Text */}
            <p className={styles.text}>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default MiniHowItWorks
